/**
 * Default payment methods configuration (International)
 *
 * This is the fallback for countries without specific configuration.
 * Only credit card payment is available internationally.
 */

export default {
  // Available payment methods for this region
  availableMethods: ['credit_card'],

  // UI configuration
  ui: {
    // Whether to show bank transfer option in trial activation
    showBankTransfer: false,
    // Whether credit card should be the primary button
    creditCardPrimary: true,
  },

  // Payment method specific settings
  settings: {
    creditCard: {
      provider: 'stripe',
    },
  },
};
